<template>
    <b-input-group-prepend v-bind="$props">
        <slot />
    </b-input-group-prepend>
</template>

<script>
import { BInputGroupPrepend } from 'bootstrap-vue'

export default {
    components: { BInputGroupPrepend },
}
</script>